import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import EventCard from "@/components/EventCard";

const HERO = "https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/w8kmnyqm_IMG20260315201701.jpg";

const STAGE_GALLERY = [
  { url: "https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/rzh8vlt4_APWTP%20-%2015.jpg", caption: "Theatre · APWTP" },
  { url: "https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/whhc2dau_IMG20221120174103%20e.webp", caption: "Panel · Conversations on stage" },
  { url: "https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/dhr0chq7_20260315_174741.jpg", caption: "A full house · Sundown session" },
];

export default function Stage() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/events", { params: { section: "stage" } }).then(r => setEvents(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="stage-page" style={{ background: "#1C1C19", color: "#F9F8F6" }}>
      <section className="relative h-[90vh] overflow-hidden">
        <img src={HERO} alt="Stage" className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0" style={{background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.25) 60%, rgba(0,0,0,0.6) 100%)"}}/>
        <div className="absolute inset-0 flex items-end p-6 md:p-12 lg:p-20">
          <div>
            <div className="overline" style={{color: "#D4A373"}}>05 — Stage</div>
            <h1 className="display text-6xl md:text-8xl lg:text-9xl mt-6" style={{color: "#F9F8F6"}}>
              An outdoor <em className="italic">stage.</em>
            </h1>
            <p className="mt-6 max-w-xl text-base" style={{ color: "#E5E4DE"}}>
              Acoustic music, theatre, dance and readings under the canopy. Limited seating, warm light,
              and a sky that performs alongside.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline" style={{color: "#9F9F95"}}>The stage</div>
            <h2 className="display text-4xl md:text-5xl mt-4">Programming with care.</h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-base leading-relaxed" style={{color: "#D2D1C9"}}>
              Our outdoor stage hosts performances drawn from across India and beyond — folk, jazz, classical
              Indian, electronic, spoken word and small theatre. Tickets are limited; we keep the audience close
              so the music never has to shout.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/events?section=stage" className="btn-ghost" style={{borderColor: "#F9F8F6", color: "#F9F8F6"}} data-testid="stage-events">See performances</Link>
              <Link to="/contact" className="btn-primary" data-testid="stage-perform">Perform with us</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stage gallery */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STAGE_GALLERY.map((s, i) => (
            <figure key={i} className={`group ${i === 1 ? "md:translate-y-8" : ""}`}>
              <div className="aspect-[4/5] overflow-hidden">
                <img src={s.url} alt={s.caption} className="reveal-img w-full h-full object-cover" loading="lazy"/>
              </div>
              <figcaption className="mt-3 overline" style={{color: "#9F9F95"}}>{s.caption}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {events.length > 0 && (
        <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 pb-24" style={{color: "#F9F8F6"}}>
          <div className="overline" style={{color: "#9F9F95"}}>Upcoming</div>
          <h2 className="display text-4xl md:text-5xl mt-4">Take a seat.</h2>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {events.map(e => (
              <Link to={`/events/${e.slug}`} key={e.id} className="group block" data-testid={`stage-event-${e.slug}`}>
                <div className="aspect-[4/5] overflow-hidden">
                  <img src={e.image_url} className="reveal-img w-full h-full object-cover" alt={e.title} loading="lazy" />
                </div>
                <div className="mt-4">
                  <div className="overline" style={{color: "#9F9F95"}}>{e.section?.replace('-', ' ')}</div>
                  <h3 className="font-serif text-2xl mt-2">{e.title}</h3>
                  <p className="text-sm mt-2" style={{color: "#D2D1C9"}}>{e.short_description}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
